import { combineReducers } from 'redux';
import authorize from './authorizeReducer';
import stationList from './stationListReducer';
import stationRecord from './stationRecordReducer';
import stationHistory from './stationHistoryReducer';
import smartQuery from './smartQueryReducer';
import fixrecord from './fixRecordReducer';
import stationUploadFile from './stationUploadFileReducer';

const rootReducers = combineReducers({
    authorize: authorize,
    stationList: stationList,
    stationRecord: stationRecord,
    stationHistory: stationHistory,
    smartQuery: smartQuery,
    fixrecord: fixrecord,
    stationUploadFile: stationUploadFile,
})

export default rootReducers;